export const CONTACT_EMAIL = 'contact@anyshift.io';
